import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Widgets' })({
    container: {
        display: 'grid',
        gap: 24,
        gridTemplateColumns: 'repeat(4, 1fr)',
        alignItems: 'stretch',
        ['@media (max-width: 960px)']: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 24,
            width: '100%'
        }
    },
    counter: {
        ['@media (max-width: 960px)']: {
            width: '100%'
        }
    },
    progression: {
        margin: 0,
        gridColumn: '1 / 3'
    },
    social: {
        margin: 0,
        gridColumn: '3 / 5'
    }
});
